import React from "react";
import { View, Text, StyleSheet, ScrollView } from "react-native";
import SvgIcon from '../components/SvgIcon';
import colors from "../theme/colors";
import { useNavigationVisibility } from '../context/NavigationVisibilityContext';

export default function FeaturesScreen() {
  const { handleScroll } = useNavigationVisibility();
  
  return (
    <ScrollView 
      style={styles.container} 
      contentContainerStyle={styles.content}
      onScroll={handleScroll}
      scrollEventThrottle={16}
    >
      <View style={styles.featuresSection}>
        <View style={styles.sectionHeader}>
          <Text style={styles.sectionTitle}>Our Unique Features</Text>
          <View style={styles.titleUnderline} />
          <Text style={styles.sectionSubtitle}>
            KalyanaMitra offers a blend of AI technology and human expertise
          </Text>
        </View>
        
        <View style={styles.featuresGrid}>
          <View style={styles.featureCard}>
            <View style={styles.featureIconContainer}>
              <SvgIcon name="people" size={24} color={colors.white} />
            </View>
            <View style={styles.featureContent}>
              <Text style={styles.featureTitle}>Mediator-Assisted Matches</Text>
              <Text style={styles.featureDescription}>
                Connect through trusted mediators who understand your preferences and help find compatible partners.
              </Text>
            </View>
          </View>
          
          <View style={styles.featureCard}>
            <View style={styles.featureIconContainer}>
              <SvgIcon name="bulb" size={24} color={colors.white} />
            </View>
            <View style={styles.featureContent}>
              <Text style={styles.featureTitle}>AI-Driven Compatibility</Text>
              <Text style={styles.featureDescription}>
                Our advanced AI analyzes profiles to generate compatibility scores, helping mediators make informed recommendations.
              </Text>
            </View>
          </View>
          
          <View style={styles.featureCard}>
            <View style={styles.featureIconContainer}>
              <SvgIcon name="shield-checkmark" size={24} color={colors.white} />
            </View>
            <View style={styles.featureContent}>
              <Text style={styles.featureTitle}>Private & Secure</Text>
              <Text style={styles.featureDescription}>
                Control your profile visibility and communicate securely within our platform with robust privacy features.
              </Text>
            </View>
          </View>
          
          <View style={styles.featureCard}>
            <View style={styles.featureIconContainer}>
              <SvgIcon name="chatbubbles" size={24} color={colors.white} />
            </View>
            <View style={styles.featureContent}>
              <Text style={styles.featureTitle}>Streamlined Communication</Text>
              <Text style={styles.featureDescription}>
                Connect through our in-app messaging system and schedule meetings with potential matches and mediators.
              </Text>
            </View>
          </View>
          
          <View style={styles.featureCard}>
            <View style={styles.featureIconContainer}>
              <SvgIcon name="checkmark-circle" size={24} color={colors.white} />
            </View>
            <View style={styles.featureContent}>
              <Text style={styles.featureTitle}>Verified Profiles</Text>
              <Text style={styles.featureDescription}>
                All profiles are verified through OTP authentication, ensuring you connect with genuine individuals.
              </Text>
            </View>
          </View>
          
          <View style={styles.featureCard}>
            <View style={styles.featureIconContainer}>
              <SvgIcon name="sparkles" size={24} color={colors.white} />
            </View>
            <View style={styles.featureContent}>
              <Text style={styles.featureTitle}>Preferences-Based Matching</Text>
              <Text style={styles.featureDescription}>
                Find matches based on match seeker's preferences to ensure practical and convenient relationships.
              </Text>
            </View>
          </View>
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  content: {
    paddingBottom: 120,
  },
  featuresSection: {
    width: "100%",
    paddingHorizontal: 24,
    paddingVertical: 50,
    backgroundColor: colors.white,
  },
  sectionHeader: {
    alignItems: "center",
    marginBottom: 40,
  },
  sectionTitle: {
    fontSize: 32,
    fontWeight: "700",
    color: colors.primary,
    textAlign: "center",
    marginBottom: 12,
  },
  titleUnderline: {
    width: 60,
    height: 4,
    backgroundColor: colors.secondary,
    borderRadius: 2,
    marginBottom: 12,
  },
  sectionSubtitle: {
    fontSize: 16,
    color: colors.textDark,
    textAlign: "center",
  },
  featuresGrid: {
    gap: 20,
  },
  featureCard: {
    backgroundColor: colors.primary,
    borderRadius: 12,
    padding: 24,
    flexDirection: "row",
    gap: 16,
  },
  featureIconContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: colors.secondary,
    alignItems: "center",
    justifyContent: "center",
  },
  featureContent: {
    flex: 1,
  },
  featureTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: colors.white,
    marginBottom: 8,
  },
  featureDescription: {
    fontSize: 14,
    color: colors.white,
    opacity: 0.8,
    lineHeight: 22,
  },
});
